/* cart-gift-smooth.js - JUV ACTIVEWEAR
 * Evita el "glitch" del cart drawer cuando BOGOS agrega/quita el regalo automatico.
 *  1) Junta todos los "cart:refresh" que llegan seguidos en UNO solo (BOGOS manda 4 por vez).
 *  2) Si llega una respuesta vieja despues de una nueva, se ignora (antes hacia desaparecer el regalo).
 *  3) Mientras el carrito se actualiza (theme o BOGOS) el drawer queda en estado "cargando".
 * Para desactivarlo: borrar la linea de este archivo en layout/theme.liquid.
 */
(function () {
  if (typeof CartDrawer === 'undefined' || CartDrawer.prototype.__juvSmooth) return;
  CartDrawer.prototype.__juvSmooth = true;

  var DEBOUNCE = 250;   // ms para juntar cart:refresh seguidos
  var GRACE = 450;      // ms de espera antes de sacar el "cargando"
  var seq = 0, timer = null, inFlight = 0, offTimer = null, safety = null;
  var bogosBusy = false, themeBusy = false;

  function drawer() { return document.getElementById('Cart-Drawer'); }

  var css = document.createElement('style');
  css.textContent =
    '#Cart-Drawer.juv-updating .side-panel-content>*{opacity:.4;transition:opacity .15s;pointer-events:none}' +
    '#Cart-Drawer.juv-updating .side-panel-inner::after{content:"";position:absolute;top:42%;left:50%;width:28px;height:28px;margin:-14px 0 0 -14px;' +
    'border:3px solid #000;border-right-color:transparent;border-radius:50%;animation:juvspin .7s linear infinite;z-index:20;pointer-events:none}' +
    '#Cart-Drawer.juv-updating [name="checkout"],#Cart-Drawer.juv-updating .cart-drawer-buttons{pointer-events:none;opacity:.6}' +
    '@keyframes juvspin{to{transform:rotate(360deg)}}';
  document.head.appendChild(css);

  function busy() { return bogosBusy || themeBusy || timer || inFlight > 0; }

  function loadingOn() {
    var d = drawer(); if (!d) return;
    clearTimeout(offTimer);
    d.classList.add('juv-updating');
    clearTimeout(safety);
    safety = setTimeout(function () { d.classList.remove('juv-updating'); }, 10000); // nunca queda trabado
  }

  function loadingOffSoon() {
    clearTimeout(offTimer);
    offTimer = setTimeout(function () {
      if (busy()) return;
      var d = drawer(); d && d.classList.remove('juv-updating');
    }, GRACE);
  }

  // Click en + / - / borrar, o cambio de cantidad: mostrar "cargando" al instante
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#Cart-Drawer .quantity button, #Cart-Drawer .remove')) loadingOn();
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('#Cart-Drawer input.qty')) loadingOn();
  }, true);

  // Theme: cambio de cantidad
  document.addEventListener('line-item:change:start', function () { themeBusy = true; loadingOn(); });
  document.addEventListener('line-item:change:end', function () { themeBusy = false; loadingOffSoon(); });

  // BOGOS: cuando esta revisando/agregando el regalo
  document.addEventListener('fg-cart:start-process', function () { bogosBusy = true; loadingOn(); });
  document.addEventListener('fg-cart:end-process', function () { bogosBusy = false; loadingOffSoon(); });

  // refresh del drawer: uno solo, y siempre gana el ultimo
  CartDrawer.prototype.refresh = function () {
    var self = this;
    loadingOn();
    clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      var my = ++seq;
      inFlight++;
      fetch(window.location.pathname + '?sections=cart-drawer,cart-bubble')
        .then(function (r) { return r.text(); })
        .then(function (state) {
          if (my !== seq) return;   // hay una respuesta mas nueva: ignorar esta
          if (bogosBusy) {          // BOGOS sigue cambiando el carrito: volver a pedir al terminar
            document.addEventListener('fg-cart:end-process', function () { self.refresh(); }, { once: true });
            return;
          }
          var parsed = JSON.parse(state);
          self.getSectionsToRender().forEach(function (section) {
            var host = document.getElementById(section.id);
            if (!host || !parsed[section.section]) return;
            var el = host.querySelector(section.selector) || host;
            el.innerHTML = self.getSectionInnerHTML(parsed[section.section], section.selector);
          });
          self.removeProductEvent();
          self.notesToggle();
          self.updateFreeShipping();
          var rec = self.container.querySelector('.product-recommendations--full');
          rec && rec.classList.add('active');
        })
        .catch(function () {})
        .finally(function () { inFlight--; loadingOffSoon(); });
    }, DEBOUNCE);
  };
})();
